import type {Theme} from '@emotion/react';

interface VariablesProps {
    $activeBorderColor?: string;
    theme: Theme;
}

/**
 * Generates base CSS variables for TagCheckbox component styling.
 *
 * @param props                    The variables properties.
 * @param props.$activeBorderColor Optional custom border color for active state.
 * @param props.theme              The emotion theme object containing color values.
 * @returns CSS string with base variable definitions.
 */
export const getBaseVariables = ({$activeBorderColor, theme}: VariablesProps) => `
    --border-color: ${theme.colors.neutral20};
    --background-color: ${theme.colors.neutral20};
    --font-color: ${theme.colors.textPrimary};

    &[data-is-single='true'] {
        --font-color: ${theme.colors.textSecondary};
    }

    &[data-active='true'] {
        --border-color: ${$activeBorderColor ?? theme.colors.primary};
        --background-color: ${theme.colors.neutral0};
        --font-color: ${theme.colors.textPrimary};
    }
`;

/**
 * Generates hover state CSS variables for TagCheckbox component styling.
 *
 * @param props                    The variables properties.
 * @param props.$activeBorderColor Optional custom border color for active state.
 * @param props.theme              The emotion theme object containing color values.
 * @returns CSS string with hover variable definitions.
 */
export const getHoverVariables = ({$activeBorderColor, theme}: VariablesProps) => `
    --background-color: ${theme.colors.neutral0};
    --border-color: ${theme.colors.neutral40};

    &[data-active='true'] {
        --border-color: ${$activeBorderColor ?? theme.colors.primary};
    }
`;